import axios from "axios";
import {API} from '../env'
import Vuex from '../store/index'

export default {
    /**
     * Login user
     * @param {object} data
     * @api {POST} api/web/login
     */
    login(data) {
        const options = {
            method: 'POST',
            url: API + 'api/web/login',
            headers: {'content-type': 'application/json'},
            params: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response);
                    Vuex.commit('editUserState', true);
                    // localStorage.setItem('token', response.data.data.token);
                    Vuex.commit('getUserToken', response.data.data.token);
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    /**
     * Register new user
     * @param {object} data
     * @returns {Promise} promise that represents the saved user and success message
     */
    register(data) {
        const options = {
            method: 'POST',
            url: API + 'api/web/register',
            headers: {'content-type': 'application/json'},
            data: {...data}
        };

        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    /**
     * Activate email after registration
     * @param {object} data
     * @returns {Promise}
     */
    activateEmail(data) {
        const options = {
            method: 'POST',
            url: API + 'api/web/activateEmail',
            headers: {'content-type': 'application/json'},
            data: {...data}
        };

        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    /**
     * Activate email after registration
     * @param {object} data
     * @returns {Promise}
     */
    resendCode(data) {
        const options = {
            method: 'POST',
            url: API + 'api/web/resendActivationCode',
            headers: {'content-type': 'application/json'},
            data: {...data}
        };

        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data.message)
                })
        })
    },

    /**
     * Forget password
     * @param {string} email
     * @returns {Promise}
     */
    forgetPassword(email) {
        const options = {
            method: 'POST',
            url: API + 'api/web/resetPassword',
            headers: {'content-type': 'application/json'},
            data: {email: email}
        };

        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data.message)
                })
        })
    }
}